import type { HydratedCurationModule } from "~types/types";

const IS_DEV = process.env.NODE_ENV === "development";

export function devModuleProps(
    module: HydratedCurationModule
): HydratedCurationModule {
    if (IS_DEV) {
        /*
            This file is used in /src/~components/Zones/index.tsx
            Add any module props to test on development
            Be sure to not commit this file, or revert it after finishing your tests

            Example: test SingleStoryHomepageLedeWithDek as every module on the page:
            return {
                ...module,
                componentName: "SingleStoryHomepageLedeWithDek"
            };
        */
        return {
            ...module,
        };
    }

    return module;
}
